export default __webpack_public_path__ + "locales/vi/ChangeUserTypeDialog.json?hash=5ad7883c329933ceb722e5a42df6ca0a";